import { Component, OnDestroy } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { map, Observable, Subscription } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';

@Component({
  selector: 'app-kb-warranty-landing-page-paragraph',
  templateUrl: './kb-warranty-landing-page-paragraph.component.html',
  styleUrl: './kb-warranty-landing-page-paragraph.component.scss',
  standalone: false
})
export class KbWarrantyLandingPageParagraphComponent implements OnDestroy {

  activeLanguage!: string;
  latestDocUrl$: Observable<string>;
  subscription = new Subscription();
  constructor(private documentService: GetDocumentService,
    private languageService: LanguageService
  ) {


  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  ngOnInit() {
    this.subscription.add(this.languageService.getActive().subscribe((lan) => {
      this.activeLanguage = lan;
    }));
    this.latestDocUrl$ = this.documentService.getDocumentByDocumentCode('Y459229').pipe(
      map((response: { url: string }) => response.url)
    );
  }
}
